import { t } from 'i18n/index';

export const handleValidation = (newComment) => {
    if (!newComment.trim()) {
        throw t('errors:commentEmpty');
    }
};